import React from "react";
import { useSelector } from "react-redux";
import { selectMovies, selectLive } from "../../slices/favoritesSlice";
import { Box, Grid } from "@mui/material";
import BackgroundPlayer from "../Vod/BackgroundPlayer";
import GroupSlider from "../Vod/GroupSlider";
import LiveSlider from "../Live/Slider";

const Movies = () => {
  const favorites = useSelector(selectMovies);
  const liveFavorites = useSelector(selectLive);

  const recentFavorite = favorites[0]?.data || null;
  const movies = favorites.map((x) => x.data);
  const channels = liveFavorites.map((x) => x.data);

  console.log('qweqweqw', channels);

  return (
    <Box
      sx={{
        height: "100vh", // Full viewport height
        overflowY: "auto", // Enable vertical scrolling
        backgroundColor: "#000", // Optional: Background color for better contrast
        padding: "1rem", // Optional: Padding for better layout
      }}
    >
      {recentFavorite ? (
        <Grid container mb={20}>
          <Grid item xs={12}>
            <BackgroundPlayer
              key={`bg-${recentFavorite.stream_id || recentFavorite.series_id}`}
              name={recentFavorite.name}
              category_id={recentFavorite.category_id}
              stream_id={recentFavorite.stream_id || recentFavorite.series_id}
              isSeries={false}
              stream_icon={recentFavorite.stream_icon || recentFavorite.cover}
              existingTmdb={recentFavorite.tmdb}
            />
          </Grid>
          <Grid item xs={12} mb={5}>
            <LiveSlider name="Live Channels" playlist={channels} />
          </Grid>
          <Grid item xs={12} mb={5} >
            <GroupSlider name="Recently watched" playlist={movies} />
          </Grid>
          <Grid item xs={12} mb={5}>
            <GroupSlider name="From your favorites" playlist={movies} />
          </Grid>
          <Grid item xs={12} mb={5}>
            <GroupSlider name="From your watchlist" playlist={movies} />
          </Grid>
        </Grid>
      ) : (
        <Box sx={{ color: "white", fontSize: "1.5rem" }}>
          No favorites or anything
        </Box>
      )}
    </Box>
  );
};

export default Movies;
